import { render, staticRenderFns } from "./BusinessDescription.vue?vue&type=template&id=0b70a0d0&scoped=true&"
import script from "./BusinessDescription.vue?vue&type=script&lang=js&"
export * from "./BusinessDescription.vue?vue&type=script&lang=js&"
import style0 from "./BusinessDescription.vue?vue&type=style&index=0&id=0b70a0d0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b70a0d0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/h5-web-gold/h5-web-gold/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0b70a0d0')) {
      api.createRecord('0b70a0d0', component.options)
    } else {
      api.reload('0b70a0d0', component.options)
    }
    module.hot.accept("./BusinessDescription.vue?vue&type=template&id=0b70a0d0&scoped=true&", function () {
      api.rerender('0b70a0d0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/about/BusinessDescription.vue"
export default component.exports